import {
  ChemicalFunction,
  ChemicalRecord,
  ChemicalRecordFormValues,
  ChemicalUnit,
  RouteFormValues,
  TransportRoute,
  TransportType
} from "../types/chemicalRecords.types";

/** Seeds the chemical add/edit form from an existing record. */
export const recordToFormValues = (rec: ChemicalRecord): ChemicalRecordFormValues => ({
  name: rec.name,
  function: rec.function || "",
  amount: rec.amount !== "" ? String(rec.amount) : "",
  unit: rec.unit,
  hasTransportRoute: rec.hasTransportRoute
});

/** Folds submitted form values into the patch shape `onAdd`/`onUpdate` expect. */
export const formValuesToRecord = (values: ChemicalRecordFormValues): Partial<ChemicalRecord> => ({
  name: values.name,
  function: values.function as ChemicalFunction,
  amount: values.amount === "" ? "" : Number(values.amount),
  unit: values.unit as ChemicalUnit,
  hasTransportRoute: values.hasTransportRoute
});

/** Seeds a transport-route edit form from an existing route. */
export const routeToFormValues = (route: TransportRoute): RouteFormValues => ({
  type: route.type || "",
  distance: route.distance !== "" ? String(route.distance) : ""
});

/** Folds submitted route form values into the patch shape route callbacks expect. */
export const formValuesToRoute = (values: RouteFormValues): Pick<TransportRoute, "type" | "distance"> => ({
  type: values.type as TransportType,
  distance: values.distance === "" ? "" : Number(values.distance)
});
